import chart from '../PriorityMatrix/chart';
import PDFMakeChartConverter from './PDFMakeChartConverter';

export default async (node, options) => {
  const chartConvertor = new PDFMakeChartConverter(chart);

  options.chartOptions = {
    axisLabels: node.meta.axisLabels,
    quadrantLabels: node.meta.quadrantLabels,
    animate: false,
  };

  return chartConvertor.convert(node, options);
};
